module.exports = __webpack_public_path__ + "img/skillgames-app-measure-1.bfa7570a.jpg";